var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"load"},[_c('div',{attrs:{"id":"redball"}}),_c('div',{staticClass:"loading"},[_vm._v("3D模型加载中，请稍后...")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }